import '../../../scss/forms.scss';
import '../../../scss/print.scss';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'react-select/dist/react-select.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './_style.scss';

import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, CardHeader, Col, Input, Label, Row } from 'reactstrap';
import { bindActionCreators } from 'redux';

import { LOGS } from '../../../constants/logs';
import * as storage from '../../../services/storage';
import * as logsActions from '../../../store/ducks/r_logs/actions';
import * as CadastrarCaixaActions from '../../../store/ducks/protocolo/recepcao/cadastrarcaixa/actions';
import moment from 'moment';

const maskDate = '__/__/____';
const dataMovimento = moment().utc().format('DD/MM/YYYY');
class CadastrarCaixa extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      numCaixaOriginal: "",
      numCaixaCopia: "",
      mostrarTxt: 'none',
      mostrarCapas: 'none',
      tipoCaixaSelecionado: "",
      codigoCaixaSelecionado: "",
      printOriginal: false,
      printCopia: false,
      reimpressao: false,
      reimpressaoOriginal: false,
      reimpressaoCopia: false,
      caixaReimpressao: "",
      showBackButton: true
    };
  }

  componentDidMount() {

    this.hideCapas();
    const nomeAplicacao = this.props.history.location.pathname.split('/')[1];
    let caixaLocalOriginal = sessionStorage.getItem(`sequencialCaixaOriginal${nomeAplicacao}`);
    let caixaLocalCopia = sessionStorage.getItem(`sequencialCaixaCopia${nomeAplicacao}`);

    /* Checagem da existencia da caixa original */
    if (caixaLocalOriginal) {
      this.setState({
        numCaixaOriginal: caixaLocalOriginal
      })
    } else {
      this.props.actions.sequencialOriginalRequest({nomeAplicacao})
    }

    /* Checagem da existencia da caixa copia */
    if (caixaLocalCopia) {
      this.setState({
        numCaixaCopia: caixaLocalCopia
      })
    } else {
      this.props.actions.sequencialCopiaRequest({nomeAplicacao})
    }

  }

  componentWillReceiveProps(nextProps) {

    if (this.props.dados.caixaOriginal !== nextProps.dados.caixaOriginal) {
      this.setState({ numCaixaOriginal: nextProps.dados.caixaOriginal })
    }

    if (this.props.dados.caixaCopia !== nextProps.dados.caixaCopia) {
      this.setState({ numCaixaCopia: nextProps.dados.caixaCopia })
    }

    if (nextProps.dados.finalizarImpressao) {

      setTimeout(() => {
        window.print();
        window.location.reload();
      }, 0);

    }

    if (nextProps.dados.finalizarReimpressao) {

      this.setState({
        tipoCaixaSelecionado: nextProps.dados.selectedCaixaReimpressao.tipo.nome
      });

      setTimeout(() => {
        this.limpar()
        window.print();
        window.location.reload();
      }, 0);

    }

  }

  limpar = () => {
    const { actions } = this.props;
    actions.clear();
  }

  formatarData(valor) {
    return !!valor ? new Date(valor).toLocaleString() : null;
  }

  showImpressao = () => {
    const tipos = {
      credito_consignado: { nome: "Crédito Consignado", codigo: "CREDITO_CONSIGNADO" },
      convenio: { nome: "Convênio", codigo: "CONVENIO" },
      correspondente: { nome: "Correspondente", codigo: "CORRESPONDENTE" },
      gestao_pendencias: { nome: "Gestão de Pendências", codigo: "GESTAO_PENDENCIA" },
    };

    const tipo_caixa = document.querySelector('.tipos_caixa:checked').value;

    this.setState({
      tipoCaixaSelecionado: tipos[tipo_caixa].nome,
      codigoCaixaSelecionado: tipos[tipo_caixa].codigo,
      reimpressao: false
    })

    this.setState({ mostrarTxt: 'none' });
    this.showCapas();
  }

  showReimpressao = () => {
    
    this.setState({
      reimpressao: true,
      mostrarTxt: 'inline-block'
    });

    this.showCapas();
    
  }

  hideCapas = () => {
    this.setState({ mostrarCapas: 'none' });
  }

  showCapas = () => {
    this.setState({ mostrarCapas: 'inline-block' });
  }

  imprimirCapasReimpressao() {
    const { caixaReimpressao, tipoCaixaSelecionado } = this.state;
    const { actions, logsActions } = this.props;

    if (!!caixaReimpressao) {

      actions.searchCaixaRequest(caixaReimpressao);

      logsActions.registerRequest({
        service: 'protocolo',
        action: LOGS.ACTIONS_TYPE.RECEPCAO.IMPRIMIR_CAIXA,
        data: {
          numCaixaOriginal: caixaReimpressao,
          tipoCaixa: tipoCaixaSelecionado,
        },
      });
      
    } else {
      toast.error("Digite uma caixa para ser pesquisada.")
    }
  }


  imprimirCapas() {
    const { actions, logsActions } = this.props;
    const {
      numCaixaOriginal,
      numCaixaCopia,
      tipoCaixaSelecionado,
      codigoCaixaSelecionado,
    } = this.state;

    const print_original = document.querySelector(".select_original").checked;
    const print_copia = document.querySelector(".select_copia").checked;

    if (!print_original && !print_copia) {
      toast.error('Selecione uma das capas para imprimir.');
      this.setState({ showBackButton: true })
      return false;
    }

    this.setState({
      printOriginal: print_original,
      printCopia: print_copia,
      showBackButton: false
    });

    const payload = [];

    if (print_original) {
      storage.removeItem('sequencialCaixaOriginal');

      payload.push({
        caixa_numero: numCaixaOriginal,
        tipo_caixa: "ORIGINAL",
        tipo: {
          nome: tipoCaixaSelecionado,
          codigo: codigoCaixaSelecionado
        }
      });
    }

    if (print_copia) {
      storage.removeItem('sequencialCaixaCopia');

      payload.push({
        caixa_numero: numCaixaCopia,
        tipo_caixa: "COPIA",
        tipo: {
          nome: tipoCaixaSelecionado,
          codigo: codigoCaixaSelecionado
        }
      });
    }

    actions.insertRequest(payload);

    logsActions.registerRequest({
      service: 'protocolo',
      action: LOGS.ACTIONS_TYPE.RECEPCAO.IMPRIMIR_CAIXA,
      data: {
        numCaixaOriginal,
        numCaixaCopia,
        tipoCaixa: tipoCaixaSelecionado,
      },
    });
  }

  renderCapa = (isCopy = false) => {

    const {
      reimpressao,
      reimpressaoCopia,
      numCaixaCopia,
      numCaixaOriginal,
      caixaReimpressao,
      tipoCaixaSelecionado,
    } = this.state;

    const getNumeroCaixa = () => {
      if (!!reimpressao) return caixaReimpressao;
      if (!!isCopy) return numCaixaCopia;
      return numCaixaOriginal;
    };

    return (
      <Col className="form-check form-check-inline" md={6}>
        <label className="input-container">
          {!reimpressao &&
            <div>
              <input className={"form-check-input " + (isCopy ? "select_copia" : "select_original")} type="checkbox" value="1" />
              <span className="checkmark checkbox"></span>
            </div>
          } 
        </label>

        <div className="container-capa-caixa">
          <Card key="card-capa-1" className="m-2 col-md-12 col-lg-8">
            <CardBody>
              <Row className="rowCardCapa">
                <Label>Bradesco Financiamentos</Label>
              </Row>
              <Row className="rowCardCapaItens">
                <Row className="mt-2">
                  <Col md={2}>
                    <div className="select-box"></div>
                  </Col>
                  <Col md={5}>
                    <label className="form-check-label">Data Movimento</label>
                  </Col>
                  <Col className="flex-row-reverse" md={5}>
                    <label>Data:{dataMovimento}</label>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={2}>
                    <div className="select-box"></div>
                  </Col>
                  <Col md={5}>
                    <label className="form-check-label">Preparação</label>
                  </Col>
                  <Col className="flex-row-reverse" md={5}>
                    <label>Data:{maskDate}</label>
                  </Col>
                </Row>
                <Row>
                  <Col md={2}>
                    <div className="select-box"></div>
                  </Col>
                  <Col md={5}>
                    <label className="form-check-label">Recepção</label>
                  </Col>
                  <Col className="flex-row-reverse" md={5}>
                    <label>Data:{maskDate}</label>
                  </Col>
                </Row>
                <Row>
                  <Col md={2}>
                    <div className="select-box"></div>
                  </Col>
                  <Col md={5}>
                    <label className="form-check-label">{isCopy || reimpressaoCopia ? "Digitalização" : "Chancela"}</label>
                  </Col>
                  <Col md={5}>
                    <label>Data:{maskDate}</label>
                  </Col>
                </Row>
                <Row>
                  <Col md={2}>
                    <div className="select-box"></div>
                  </Col>
                  <Col md={5}>
                    <label className="form-check-label">{isCopy || reimpressaoCopia ? "Expurgo" : "Digitalização"}</label>
                  </Col>
                  <Col md={5}>
                    <label>Data:{maskDate}</label>
                  </Col>
                </Row>
                <Row>
                  <Col md={2}>
                    {isCopy || reimpressaoCopia ? null : <div className="select-box"></div>}
                  </Col>
                  <Col md={5}>
                    <label className="form-check-label">{isCopy || reimpressaoCopia ? null : "Expedição"}</label>
                  </Col>
                  <Col md={5}>
                    {isCopy || reimpressaoCopia ? null : <label>Data:{maskDate}</label>}
                  </Col>
                </Row>
              </Row>
              <Row className="rowCardCapaNCaixa">
                <label>
                  Caixa: {getNumeroCaixa()}
                </label>
              </Row>
              <Row className="rowCardCapa">
                <Label>{tipoCaixaSelecionado}</Label>
              </Row>
            </CardBody>
          </Card>
        </div>
      </Col>
    )
  }

  divsToPrint = () => {

    return (
      <div className="to-print">

        <div className="page-item">
          <div className="cadastrar-caixa-capa">

            <h1>Impressão de Cadastramento de Caixas</h1>

            {(this.state.printOriginal || (this.state.reimpressao && this.state.reimpressaoOriginal)) &&
              <div className="cadastrar-caixa-capa__grid">
                <div className="cadastrar-caixa-capa__container">
                  <div className="cadastrar-caixa-capa__container__header">Bradesco Financiamentos</div>
                  <div className="cadastrar-caixa-capa__container__body">

                    <div className="cadastrar-caixa-capa__container__body_line">
                      <div className="select-box"></div><label className="line-title">Data Movimento</label><label>Data:{dataMovimento}</label>
                    </div>

                    <div className="cadastrar-caixa-capa__container__body_line">
                      <div className="select-box"></div><label className="line-title">Preparação</label><label>Data:{maskDate}</label>
                    </div>

                    <div className="cadastrar-caixa-capa__container__body_line">
                      <div className="select-box"></div><label className="line-title">Recepção</label><label>Data:{maskDate}</label>
                    </div>

                    <div className="cadastrar-caixa-capa__container__body_line">
                      <div className="select-box"></div><label className="line-title">Chancela</label><label>Data:{maskDate}</label>
                    </div>

                    <div className="cadastrar-caixa-capa__container__body_line">
                      <div className="select-box"></div><label className="line-title">Digitalização</label><label>Data:{maskDate}</label>
                    </div>

                    <div className="cadastrar-caixa-capa__container__body_line">
                      <div className="select-box"></div><label className="line-title">Expedição</label><label>Data:{maskDate}</label>
                    </div>

                    <p className="numero-caixa">Caixa: {this.state.reimpressao ? this.state.caixaReimpressao : this.state.numCaixaOriginal}</p>

                  </div>
                  <div className="cadastrar-caixa-capa__container__footer">{this.state.tipoCaixaSelecionado}</div>
                </div>
              </div>
            }

            {(this.state.printCopia || (this.state.reimpressao && this.state.reimpressaoCopia)) &&
              <div className="cadastrar-caixa-capa__grid">
                <div className="cadastrar-caixa-capa__container">
                  <div className="cadastrar-caixa-capa__container__header">Bradesco Financiamentos</div>
                  <div className="cadastrar-caixa-capa__container__body">

                    <div className="cadastrar-caixa-capa__container__body_line">
                      <div className="select-box"></div><label className="line-title">Data Movimento</label><label>Data:{dataMovimento}</label>
                    </div>
                    <div className="cadastrar-caixa-capa__container__body_line">
                      <div className="select-box"></div><label className="line-title">Preparação</label><label>Data:{maskDate}</label>
                    </div>
                    <div className="cadastrar-caixa-capa__container__body_line">
                      <div className="select-box"></div><label className="line-title">Recepção</label><label>Data:{maskDate}</label>
                    </div>
                    <div className="cadastrar-caixa-capa__container__body_line">
                      <div className="select-box"></div><label className="line-title">Digitalização</label><label>Data:{maskDate}</label>
                    </div>
                    <div className="cadastrar-caixa-capa__container__body_line">
                      <div className="select-box"></div><label className="line-title">Expurgo</label><label>Data:{maskDate}</label>
                    </div>
                    <p className="numero-caixa">Caixa: {this.state.numCaixaCopia}</p>
                  </div>
                  <div className="cadastrar-caixa-capa__container__footer">{this.state.tipoCaixaSelecionado}</div>
                </div>
              </div>
            }

          </div>
        </div>

      </div>

    )

  }

  handleReimpressaoCaixa = (e) => {
    this.setState({
      caixaReimpressao: e.target.value,
      reimpressaoOriginal: e.target.value.substr(e.target.value.length - 1, 1) === 'O' || e.target.value.substr(e.target.value.length - 1, 1) !== 'C',
      reimpressaoCopia: e.target.value.substr(e.target.value.length - 1, 1) === 'C',
    })
  }

  currentApplicationPath = (history) => {
    const match = history.location.pathname.split('/');
    return match[1]
  };

  render() {
    return (

      <div className="cadastro-caixa-container">

        {this.divsToPrint()}

        <Row className="not-print">
          <Col sm={8} md={12} style={{ flexBasis: 'auto' }}>
            <Card>
              <CardHeader>
                <strong>Cadastro de Caixa</strong>{' '}
              </CardHeader>
              <CardBody>
                <form className="needs-validation">
                  <Col className="form-row justify-content-start">
                    <Row className="mt-2 col-md-12 col-sm-12 col-lg-12 col-xs-12">
                      <Label>Selecione o tipo de Caixa</Label>
                    </Row>
                    <Row className="mt-2 col-md-12 col-sm-12 col-lg-12 col-xs-12">
                      {this.currentApplicationPath(this.props.history) === 'formalizacao' &&(
                        <Col className="form-check form-check-inline" md={2}>
                        <label className="input-container" htmlFor="inlineRadio1">
                          <input
                            className="form-check-input tipos_caixa"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio1"
                            value="credito_consignado"
                            onClick={this.showImpressao}
                          />
                          <span className="checkmark radio"></span>
                          Crédito Consignado
                        </label>
                      </Col>
                      )}
                      {this.currentApplicationPath(this.props.history) === 'convenios' &&(
                        <Col className="form-check form-check-inline" md={2}>
                        <label className="input-container" htmlFor="inlineRadio2">
                          <input
                            className="form-check-input tipos_caixa"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio2"
                            value="convenio"
                            onClick={this.showImpressao}
                          />
                          <span className="checkmark radio"></span>
                          Convênio
                        </label>
                      </Col>
                      )}
                      {this.currentApplicationPath(this.props.history) === 'correspondente' &&(
                      <Col className="form-check form-check-inline" md={2}>
                        <label className="input-container" htmlFor="inlineRadio3">
                          <input
                            className="form-check-input tipos_caixa"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio3"
                            value="correspondente"
                            onClick={this.showImpressao}
                          />
                          <span className="checkmark radio"></span>
                          Correspondente
                        </label>
                      </Col>
                      )}
                      {this.currentApplicationPath(this.props.history) === 'gestaopendencias' &&(
                      <Col className="form-check form-check-inline" md={2}>
                        <label className="input-container" htmlFor="inlineRadio4">
                          <input
                            className="form-check-input tipos_caixa"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio4"
                            value="gestao_pendencias"
                            onClick={this.showImpressao}
                          />
                          <span className="checkmark radio"></span>
                          Gestão de Pendências
                        </label>
                      </Col>
                      )}
                      <Col className="form-check form-check-inline" md={4}>
                        <Row>
                          <label className="input-container" htmlFor="inlineRadio5">
                            <input
                              className="form-check-input tipos_caixa"
                              type="radio"
                              name="inlineRadioOptions"
                              id="inlineRadio5"
                              value="option5"
                              onClick={this.showReimpressao}
                            />
                            <span className="checkmark radio"></span>
                            Reimpressão
                          </label>

                          <div className="ml-4" style={{ display: this.state.mostrarTxt }}>
                            <Input
                              innerRef={element => (this.numero_caixa_reimpressao = element)}
                              name='numero_caixa_reimpressao'
                              type='text'
                              className='form-control mb-0'
                              placeholder='Número da Caixa'
                              onChange={this.handleReimpressaoCaixa}
                            />
                          </div>

                        </Row>
                      </Col>
                      <Col className="d-flex flex-row-reverse" sm={3} md={1}>
                        <Button onClick={() => this.state.reimpressao ? this.imprimirCapasReimpressao() : this.imprimirCapas()}>
                          Imprimir
                        </Button>
                      </Col>
                    </Row>

                    <Row className="mt-3 col-md-12 col-sm-12 col-lg-12 col-xs-12 to-print" style={{ display: this.state.mostrarCapas }}>
                      {this.renderCapa()}
                      {!this.state.reimpressao && this.renderCapa(true)}
                    </Row>
                  </Col>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  dados: state.cadastrarCaixaReducer
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(CadastrarCaixaActions, dispatch),
  logsActions: bindActionCreators(logsActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CadastrarCaixa);
